var map = {
	"./core/DataGrid.vue": "efae",
	"./core/Drawer.vue": "41c0",
	"./core/DxGrid.vue": "dc37",
	"./core/ExampleComponent.vue": "c824",
	"./core/Filter.vue": "b2ab",
	"./core/Footer.vue": "7a74",
	"./core/Table.vue": "936a",
	"./core/Toolbar.vue": "d23b",
	"./core/VgtFilterRow.vue": "4e9a",
	"./core/VgtGlobalSearch.vue": "991f",
	"./core/VgtHeaderRow.vue": "daf9",
	"./core/VgtPagination.vue": "2881",
	"./core/VgtPaginationPageInfo.vue": "00a9",
	"./core/VgtTableHeader.vue": "a322",
	"./core/View.vue": "9306e",
	"./helper/Offset.vue": "c6cc",
	"./material/Card.vue": "e3a9",
	"./material/ChartCard.vue": "78d5",
	"./material/Notification.vue": "9d6c",
	"./material/StatsCard.vue": "42e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe0";